export const FORM_NAME = 'cargo-express-delivery-form';

export const REQUIRED_FIELDS = ['done_at'];

export const REQUEST_ERROR_MESSAGE = 'Ошибка сервера';
